<template>
  <div class="orderList-view view pa24">
    <div class="listContainer">
      <div class="itemWrap">
        <div class="itemBlockWrap" v-for="item in tableData" :key="item.createTime">
          <div class="itemBlock" :style="{backgroundImage: `url(${item.thumbnailImg})`}">
            <div class="itemBlockMask">
            <!-- <el-button class="itemButton" size="mini" @click="editModal(scope.row)">编辑模版</el-button> -->
            <el-button class="itemButton" size="mini" @click="createPage(item)" :disabled="!hasPermi">创建页面</el-button>
            <el-button class="itemButton" size="mini" @click="lookModal(item)">查看</el-button>
            <!-- <el-button class="itemButton" size="mini" @click="delModal(scope.row)">删除</el-button> -->
            </div>
          </div>
          <div class="itemTitle"><span>{{item.title}}</span></div>
        </div>
      </div>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          class="my_pagination"
          :total="total"
          :pager-count="5"
        />
    </div>

  </div>
</template>

<script>
import { fetchCustomPage, fetchDeletePage } from '@/api/customPage'
export default {
  name: "customlist",
  components: {
  },
  data() {
    return {
      hasPermi: true,
      pickerValue: "", //下单时间
      loading:false,
      total: 0, //总条数
      currentPage: 1, //当前页数
      start:'',
      end:'',
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      // 弹窗
      dialogFormVisible: false,
      ruleForm: {
        number: "",
        remark : "",
      },
      rules: {
        number: [{ required: true, message: "请输入数量", trigger: "blur" }],
      },
      curId: null,
    };
  },
  created() {
    this.selectOrdersInfoPcAsync();
    if(JSON.parse(localStorage.getItem('isSourceAdmin'))) {
      this.hasPermi = false
    }
  },
  watch:{
  },
  filters: {
  },
  methods: {
    lookModal(data) {
      this.$router.push({ path: '/mkc/customPageShow', query: { data: JSON.stringify(data) }})
    },
    async delModal(data) {
      this.$confirm("确定删除此模版吗?", "提示", {
        onConfirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info ",
      })
      .then(() => {
        fetchDeletePage(data.id)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: "success",
              message: "操作成功！",
            });
            this.selectOrdersInfoPcAsync();
          }
        })
        
      })
    },
    editModal(data) {
      this.$router.push({ path: '/mkc/customPage', query: { templateId: data.id , type:'editTemplate', templateType: 1}})
    },
    createPage(data) {
      this.$router.push({ path: '/mkc/customPage', query: { templateId: data.id , type:'addPage', templateType: 1 }})
    },
    /**@method 获取页面列表 */
    async selectOrdersInfoPcAsync() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: 1,
      }
      const result = await fetchCustomPage(params)
      this.tableData = result.data.list
      this.total = result.data.total
      console.log(result)
    //   this.tableData = [
    //   {
    //     date: '2016-05-02',
    //     name: '大同黄花页面',
    //     types: '0',
    //     list: {
    //       'bgList': { 'type': 'pages', 'picImg': '', 'pageName': '大同黄花海报页面', 'content': '整个页面设置', 'align': 'left', 'fontSize': 16, 'weight': 'normal', 'bgColor': 'transparent', 'paddTop': 0, 'paddLeft': 0, 'textColor': '#000', 'bgImg': '',
    //         'picList': [{ 'url': 'http://pic.idshanxi.com/qhsx/posterFlower.jpg', 'width': '100' }], 'link': '' },
    //       'pageList': [
    //         {
    //           'type': 'mulImage',
    //           'paddTop': 57,
    //           'paddLeft': 36,
    //           'align': 'right',
    //           'picList': [{ 'url': '/api/base/page/53451cc2b049ae9ec8476c4512dd74ce.png', 'width': '24.00%' }],
    //           'picList[0].url': '/api/base/page/53451cc2b049ae9ec8476c4512dd74ce.png'
    //         },
    //         { 'type': 'assist',
    //           'eleHeight': 27,
    //           'bgColor': 'transparent'
    //         },
    //         { 'type': 'mulImage',
    //           'paddTop': 40,
    //           'paddLeft': 16,
    //           'align': 'right',
    //           'picList': [{ 'url': '/api/base/page/0b5b6f717e1af8731118f2fd7c465c0b.jpg', 'width': '30.00%' }],
    //           'picList[0].url': '/api/base/page/0b5b6f717e1af8731118f2fd7c465c0b.jpg'
    //         }
    //       ]
    //     }
    //   },
    //   {
    //     date: '2016-05-04',
    //     name: '防伪二维码',
    //     types: '1',
    //     list: {
    //       'bgList': { 'type': 'pages', 'picImg': '', 'pageName': '大同黄花海报页面', 'content': '整个页面设置', 'align': 'left', 'fontSize': 16, 'weight': 'normal', 'bgColor': 'transparent', 'paddTop': 0, 'paddLeft': 0, 'textColor': '#000', 'bgImg': '', 'picList': [{ 'url': 'http://pic.idshanxi.com/qhsx/posterFlower.jpg', 'width': '100' }], 'link': '' },
    //       'pageList': [{ 'type': 'scanOne', 'picImg': '', 'content': 'renxing哈哈', 'align': 'left', 'fontSize': 16, 'weight': 'normal', 'quStatus': '1', 'bgColor': '#eee', 'paddTop': 0, 'paddLeft': 0, 'textColor': '#000', 'bgImg': '', 'picList': [{ 'url': 'http://pic.idshanxi.com/qhsx/flowerBanner.png', 'width': '100' }], 'link': 'http://pic.idshanxi.com/qhsx/flowerBanner.png' }]
    //     }
    //   }, {
    //     date: '2016-05-01',
    //     name: '王小虎',
    //     types: '2',
    //     list: {}
    //   },
    //   {
    //     date: '2021-09-22',
    //     name: '潞安娜',
    //     types: '1',
    //     list: {
    //       'bgList': { 'type': 'pages', 'picImg': '', 'pageName': '潞安娜', 'content': '整个页面设置', 'align': 'left', 'fontSize': 16, 'weight': 'normal', 'bgColor': 'transparent', 'paddTop': 0, 'paddLeft': 0, 'textColor': '#000', 'bgImg': ''},
    //       'pageList' : [
    //         {"type":"mulImage","paddTop":0,"paddLeft":0,"align":"left","picList":[{"url":"/api/base/page/a5dd03eac84f458354f0a5b91b7ea92c.jpg","width":"100.00%"}]},
    //         {"type":"scanOne","picImg":"","content":"renxing哈哈","align":"left","fontSize":16,"weight":"normal","quStatus":"1","bgColor":"transparent","paddTop":0,"paddLeft":0,"textColor":"#000","bgImg":"","picList":[{"url":"http://pic.idshanxi.com/qhsx/flowerBanner.png","width":"100"}],"link":"http://pic.idshanxi.com/qhsx/flowerBanner.png"},
    //         {"type":"mulImage","paddTop":0,"paddLeft":0,"align":"left","picList":[{"url":"/api/base/page/fe74709e8a66eb7361dbf3c8930edd63.jpg","width":"100%"},{"url":"/api/base/page/5a98e79d3ecb1b308ff05ba5d30afcf9.jpg","width":"100%"}]},
    //         {"type":"imgTextList","wrapTit":"牡丹精粹亮活养颜套装","wrapTitColor":"#000","wrapEnTit":"RAISE COLOUR COMBINATION","wrapEnTitColor":"#666","bgColor":"#fff","paddTop":10,"paddLeft":10,"picList":[{"url":"/api/base/page/ef70a5c7ba5bbb7017739ab3b8cec439.jpg","width":"30%","link":"","subTitle":"","title":"光透亮妍清爽醒肤花萃水","content":"光果甘草，净化型牡丹精粹，附有生物提取物，让皮肤更加透亮。","imgAlign":"row","imgRadius":0,"conWrapAlign":"center","titleAlign":"left","titleColor":"#000","titPaddTop":0,"titleSize":16,"subTitColor":"#313131","subTitleSize":12,"contentAlign":"left","contentColor":"#666","contentSize":12,"isShowLine":false,"lineColor":"#000"},{"url":"/api/base/page/afe24a2154a0d5b72c83fd92ee56f100.jpg","width":"30%","link":"","subTitle":"","title":"光透亮妍活润爽泽荟萃乳","content":"一瓶四效，润养修护，提升肌肤滋润度，强韧肌底屏障。","imgAlign":"row-reverse","imgRadius":0,"conWrapAlign":"center","titleAlign":"left","titleColor":"#000","titPaddTop":0,"titleSize":16,"subTitColor":"#313131","subTitleSize":12,"contentAlign":"left","contentColor":"#666","contentSize":12,"isShowLine":false,"lineColor":"#000"},{"url":"/api/base/page/ef70a5c7ba5bbb7017739ab3b8cec439.jpg","width":"30%","link":"","subTitle":"","title":"氨基酸花萃轻润洁肤泡沫","content":"轻盈绵密质地，水漾丝滑，精选龙舌兰叶，润泽滋润。","imgAlign":"row","imgRadius":0,"conWrapAlign":"center","titleAlign":"left","titleColor":"#000","titPaddTop":0,"titleSize":16,"subTitColor":"#313131","subTitleSize":12,"contentAlign":"left","contentColor":"#666","contentSize":12,"isShowLine":false,"lineColor":"#000"},{"url":"/api/base/page/9a5abeb3bbf1375dae88854aa3c2d9bb.jpg","width":"30%","link":"","subTitle":"","title":"卓能甄粹水光修复面膜","content":"3%高纯度二裂酵母，肌肤下猛料，强韧肌肤屏障。","imgAlign":"row-reverse","imgRadius":0,"conWrapAlign":"center","titleAlign":"left","titleColor":"#000","titPaddTop":0,"titleSize":16,"subTitColor":"#313131","subTitleSize":12,"contentAlign":"left","contentColor":"#666","contentSize":12,"isShowLine":false,"lineColor":"#000"}]}
    //       ]
    //     },
    //   },
    //   {
    //     date: '2021-10-11',
    //     name: '神农药皂',
    //     types: '1',
    //     list: {
    //       'bgList': { 'type': 'pages', 'picImg': '', 'pageName': '神农药皂', 'content': '整个页面设置', 'align': 'left', 'fontSize': 16, 'weight': 'normal', 'bgColor': 'transparent', 'paddTop': 0, 'paddLeft': 0, 'textColor': '#000', 'bgImg': ''},
    //       'pageList' :[
    //         {"type":"mulImage","paddTop":0,"paddLeft":0,"align":"left","picList":[{"url":"/api/base/page/78cac488d725c5c75071c9501b67454a.png","width":"100.00%"}]},
    //         {"type":"scanTwo","paddTop":20,"paddLeft":10,"bgColor":"#FACB47","titleAlign":"center","title":"防伪二维码","titleSize":18,"titleColor":"#000","subTitle":"Anti-counterfeiting QR Code","subTitleSize":12,"subTitleColor":"#000","picList":[{"url":"/api/base/page/7cd4c4a971696a010d73cc471b8d0452.png","link":""}]},
    //         {"type":"imgText2","bgColor":"#fff","paddTop":10,"paddLeft":10,"isShowLine":true,"lineColor":"#3A3E3A","lineWidth":56,"picList":[{"url":"/api/base/page/8bc7df0efbf14f57fc605afc54f0cade.png","width":"100%","link":"","title":"化繁为简，圆方互容","titleColor":"#000","titleSize":18,"subTitle":"澄庆系列","subTitleColor":"#1D211D","subTitleSize":14},{"url":"/api/base/page/79c763edc24ee5e6710efb05d54ac869.png","width":"100%","link":"","title":"萃药茶入皂，享草本精华","titleColor":"#000","titleSize":18,"subTitle":"澄庆系列","subTitleColor":"#1D211D","subTitleSize":14}]},
    //         {"type":"tit1","marginTop":0,"marginLeft":10,"paddTop":10,"paddLeft":10,"content":"连翘叶手工皂","align":"left","fontSize":18,"fontWeight":"bold","textColor":"#1D211D","isShowLine":true,"lineColor":"#1D211D"},
    //         {"type":"con1","isShowLine":true,"list":[{"label":"产品规格：","content":"100g/盒"},{"label":"产品功效：","content":"温和清洁、醒肤抑菌"}]},
    //         {"type":"detailBlock1","bgColor":"#F7F7F7","conBgColor":"#fff","paddLeft":10,"paddTop":10,"isShowLine":true,"lineType":1,"title":"连翘叶手工皂","titleColor":"#000","titleSize":18,"enTitle":"About Shennong Jincha","enTitleColor":"#000","enTitleSize":12,"contents":[{"content":"萃药茶入皂，享草本精华。茶颜皂势，取法古方，药茶精粹成分混合天然橄榄油，温和亲肤搭配绵密沁香泡沫，清洁肌肤+舒缓修护，细腻之余带走忙碌生活中的疲惫和尘埃，柔嫩的不止是肌肤，更是放松后的心灵，一皂在手，化繁为简，圆方互容，开启健康生活新风尚。"}],"contentColor":"#000","contentSize":12},
    //         {"type":"detailBlock1","bgColor":"#F7F7F7","conBgColor":"#fff","paddLeft":10,"paddTop":10,"isShowLine":true,"lineType":1,"title":"关于神农晋茶","titleColor":"#000","titleSize":18,"enTitle":"About Shennong Jincha","enTitleColor":"#000","enTitleSize":12,"contentColor":"#000","contentSize":12,"contents":[{"content":"         山西神农氏晋茶作为山西省首批授权使用“山西药茶”区域公用品牌的企业，以山西省丰富的野生连翘资源为基础，集成制药及食品研究关键技术，打造具有山西道地特色的山西药茶品牌，挖掘山西道地药材资源价值，助力我省山西药茶产业发展。研究分析表明，连翘叶中含有丰富的Mg、Zn、Se等人体所需元素以及多种对人体有益的氨基酸和丰富的维生素P；连翘叶采摘的最佳时期是4月中旬-6月中旬，嫩芽的品质最好。"},{"content":"连翘叶茶饮在山西历史悠久，民间用连翘嫩叶制成茶饮用的历史已有数百年，在乾隆年间，山西产的连翘茶曾被当做贡品。科学研究表明，连翘叶提取物可以保护人体细胞免受氧化损伤，治温热，降血脂，散诸经血结气聚，具有败火散结，保肝护肝、生津利咽、清凉提神等功效。因此，富含多种营养成分、无公害、纯绿色的野生连翘茶是人们健康生活应备的品质好茶。目前神农晋茶生产基地位于运城市绛县，采用了自主知识产权的山西药茶特制生产线，并由浙江知名茶叶生产线制造商进行制造。"},{"content":"神农晋茶目前集连翘叶、党参、蒲公英、黄精等食药同源材料的采摘、种植、生产、加工、安全检测、产品研发、全渠道销售、文化研究推广于一体，在山西省晋中市、运城市、长治市、临汾市等地规划建有全国领先且具有独立知识产权的现代化大中型生产线及原料基地，力争成为奉献健康、改变生活方式的行业领头羊。"}]}
    //         ]
    //     },
    //   },
    //   {
    //     date: '2021-10-11',
    //     name: '神农药枕',
    //     types: '1',
    //     list: {
    //       'bgList': { 'type': 'pages', 'picImg': '', 'pageName': '神农药枕', 'content': '整个页面设置', 'align': 'left', 'fontSize': 16, 'weight': 'normal', 'bgColor': 'transparent', 'paddTop': 0, 'paddLeft': 0, 'textColor': '#000', 'bgImg': ''},
    //       'pageList' :[
    //         {"type":"mulImage","paddTop":0,"paddLeft":0,"align":"left","picList":[]},
    //         {"type":"mulImage","paddTop":0,"paddLeft":0,"align":"left","picList":[{"url":"/api/base/page/597075504c6d19ac6681c7e950a5ffbb.png","width":"100.00%"}]},
    //         {"type":"scanTwo","paddTop":20,"paddLeft":10,"bgColor":"#FACB47","titleAlign":"center","title":"防伪二维码","titleSize":18,"titleColor":"#000","subTitle":"Anti-counterfeiting QR Code","subTitleSize":12,"subTitleColor":"#000","picList":[{"url":"/api/base/page/7cd4c4a971696a010d73cc471b8d0452.png","link":""}]},
    //         {"type":"imgText2","bgColor":"#fff","paddTop":10,"paddLeft":10,"isShowLine":true,"lineColor":"#3A3E3A","lineWidth":56,"picList":[{"url":"/api/base/page/c733231bf3b1a7bbea83435c60d9eced.png","width":"100%","link":"","title":"每天一枕，让颈椎更放松","titleColor":"#000","titleSize":18,"subTitle":"神农药枕","subTitleColor":"#1D211D","subTitleSize":14},{"url":"/api/base/page/1b865c086ba8b75174c2a1e4840695ab.png","width":"100%","link":"","title":"矫正修复颈椎曲度","titleColor":"#000","titleSize":18,"subTitle":"神农药枕","subTitleColor":"#1D211D","subTitleSize":14}]},
    //         {"type":"tit1","marginTop":0,"marginLeft":10,"paddTop":10,"paddLeft":10,"content":"药茶降压安神枕","align":"left","fontSize":18,"fontWeight":"bold","textColor":"#1D211D","isShowLine":true,"lineColor":"#1D211D"},
    //         {"type":"con1","isShowLine":false,"list":[{"label":"保质期：","content":"2年"},{"label":"产品注意：","content":"需放置干燥的地方，多晾晒"}]},
    //         {"type":"mulImage","paddTop":0,"paddLeft":0,"align":"left","picList":[{"url":"/api/base/page/59be33892ddf0de96af52e5dae3aa4c4.png","width":"100.00%"}]},
    //         {"type":"imgTextList","wrapTit":"价值功效","wrapTitColor":"#000","wrapEnTit":"Shennong Jincha value effect","wrapEnTitColor":"#666","bgColor":"#fff","paddTop":10,"paddLeft":10,"picList":[{"url":"/api/base/page/1437c3312f95e3b22b59e3b528c7ad85.png","width":"60%","link":"","subTitle":"Efficacy 1","title":"功效1","content":"健脾养胃，清肝去火 安神健脑，促进睡眠","imgAlign":"row-reverse","imgRadius":0,"conWrapAlign":"center","titleAlign":"left","titleColor":"#000","titPaddTop":1,"titleSize":22,"subTitColor":"#313131","subTitleSize":12,"contentAlign":"left","contentColor":"#666","contentSize":12,"isShowLine":true,"lineColor":"#000"},{"url":"/api/base/page/7394dcc092d34cd4b61fa63dcec356eb.png","width":"60%","link":"","subTitle":"Efficacy 2","title":"功效2","content":"辅助治疗高血压 安神助眠","imgAlign":"row","imgRadius":0,"conWrapAlign":"center","titleAlign":"left","titleColor":"#000","titPaddTop":0,"titleSize":22,"subTitColor":"#313131","subTitleSize":12,"contentAlign":"left","contentColor":"#666","contentSize":12,"isShowLine":true,"lineColor":"#000"},{"url":"/api/base/page/4e6f549d30303738e7f7ee86cc9f0c88.png","width":"60%","link":"","subTitle":"Efficacy 3","title":"功效3","content":"舒压养颜，缓解生闷气、 抑郁等带不良情绪，安神 助眠。","imgAlign":"row-reverse","imgRadius":0,"conWrapAlign":"center","titleAlign":"left","titleColor":"#000","titPaddTop":0,"titleSize":22,"subTitColor":"#313131","subTitleSize":12,"contentAlign":"left","contentColor":"#666","contentSize":12,"isShowLine":true,"lineColor":"#000"},{"url":"/api/base/page/5e474368718dda3a3d62daaa84ca956c.png","width":"60%","link":"","subTitle":"Efficacy 4","title":"功效4","content":"释放神经压力，清肝 明目，安神助眠","imgAlign":"row","imgRadius":0,"conWrapAlign":"center","titleAlign":"left","titleColor":"#000","titPaddTop":0,"titleSize":22,"subTitColor":"#313131","subTitleSize":12,"contentAlign":"left","contentColor":"#666","contentSize":12,"isShowLine":true,"lineColor":"#000"}]},
    //         {"type":"detailBlock1","bgColor":"rgba(193, 159, 131, 1)","conBgColor":"#fff","paddLeft":10,"paddTop":10,"isShowLine":true,"lineType":1,"title":"药茶降压安神枕","titleColor":"#000","titleSize":18,"enTitle":"Herbal tea soothing pillow","enTitleColor":"#000","enTitleSize":12,"contents":[{"content":"颈椎是人体十分重要的十字路口，又称阳脉之海，一旦颈椎出现问题，脉络就会出问题，脉络出了问题，整个身体都会生病。所以，维护健康的源头，就是要从枕头开始。药茶古方健康枕遵循自然法则，采用道地药茶为原料，以绿色天然、绿色健康为本，依据中国传统医学理论，应用现代高科技技术而制成。古法传承，潜心制造。放松解压，安神助眠。一世人半世枕，健康从“头”到“脚”出发。"}],"contentColor":"#000","contentSize":12},
    //         {"type":"detailBlock1","bgColor":"rgba(193, 159, 131, 1)","conBgColor":"#fff","paddLeft":10,"paddTop":10,"isShowLine":true,"lineType":1,"title":"关于神农晋茶","titleColor":"#000","titleSize":18,"enTitle":"About Shennong Jincha","enTitleColor":"#000","enTitleSize":12,"contents":[{"content":" 山西神农氏晋茶作为山西省首批授权使用“山西药茶”区域公用品牌的企业，以山西省丰富的野生连翘资源为基础，集成制药及食品研究关键技术，打造具有山西道地特色的山西药茶品牌，挖掘山西道地药材资源价值，助力我省山西药茶产业发展。研究分析表明，连翘叶中含有丰富的Mg、Zn、Se等人体所需元素以及多种对人体有益的氨基酸和丰富的维生素P；连翘叶采摘的最佳时期是4月中旬-6月中旬，嫩芽的品质最好。"},{"content":"连翘叶茶饮在山西历史悠久，民间用连翘嫩叶制成茶饮用的历史已有数百年，在乾隆年间，山西产的连翘茶曾被当做贡品。科学研究表明，连翘叶提取物可以保护人体细胞免受氧化损伤，治温热，降血脂，散诸经血结气聚，具有败火散结，保肝护肝、生津利咽、清凉提神等功效。因此，富含多种营养成分、无公害、纯绿色的野生连翘茶是人们健康生活应备的品质好茶。目前神农晋茶生产基地位于运城市绛县，采用了自主知识产权的山西药茶特制生产线，并由浙江知名茶叶生产线制造商进行制造。"},{"content":"神农晋茶目前集连翘叶、党参、蒲公英、黄精等食药同源材料的采摘、种植、生产、加工、安全检测、产品研发、全渠道销售、文化研究推广于一体，在山西省晋中市、运城市、长治市、临汾市等地规划建有全国领先且具有独立知识产权的现代化大中型生产线及原料基地，力争成为奉献健康、改变生活方式的行业领头羊。"}],"contentColor":"#000","contentSize":12}
    //         ]
    //     }
    //   },
    //   {
    //     date: '2021-10-11',
    //     name: '神农药茶',
    //     types: '1',
    //     list: {
    //       'bgList': { 'type': 'pages', 'picImg': '', 'pageName': '神农药茶', 'content': '整个页面设置', 'align': 'left', 'fontSize': 16, 'weight': 'normal', 'bgColor': 'transparent', 'paddTop': 0, 'paddLeft': 0, 'textColor': '#000', 'bgImg': ''},
    //       'pageList': [
    //         {"type":"mulImage","paddTop":0,"paddLeft":0,"align":"left","picList":[{"url":"/api/base/page/ccee9733e668ecbfde1af46cc2e0b12f.png","width":"100.00%"}]},
    //         {"type":"scanTwo","paddTop":20,"paddLeft":10,"bgColor":"#FACB47","titleAlign":"center","title":"防伪二维码","titleSize":18,"titleColor":"#000","subTitle":"Anti-counterfeiting QR Code","subTitleSize":12,"subTitleColor":"#000","picList":[{"url":"/api/base/page/43c0697bc83bad58e9fb6528c171246c.png","link":""}]},
    //         {"type":"imgText2","bgColor":"#fff","paddTop":10,"paddLeft":10,"isShowLine":true,"lineColor":"#3A3E3A","lineWidth":56,"picList":[{"url":"/api/base/page/cb0e882d8a96f7f92d75a6a0948dd314.png","width":"100%","link":"","title":"以产品、细节惊艳消费者","titleColor":"#000","titleSize":18,"subTitle":"神农晋茶","subTitleColor":"#1D211D","subTitleSize":14},{"url":"/api/base/page/428f3fc134ffa32de93bd7b6e60fe5e2.png","width":"100%","link":"","title":"通过组方茶抓住年轻顾客的心","titleColor":"#000","titleSize":18,"subTitle":"神农晋茶","subTitleColor":"#1D211D","subTitleSize":14}]},
    //         {"type":"tit1","marginTop":0,"marginLeft":10,"paddTop":10,"paddLeft":10,"content":"澄瑞冰蓝-连翘茶","align":"left","fontSize":18,"fontWeight":"bold","textColor":"#1D211D","isShowLine":true,"lineColor":"#1D211D"},
    //         {"type":"con1","isShowLine":true,"list":[{"label":"产品规格：","content":"250g/盒"},{"label":"原料：","content":"连翘叶"},{"label":"保质期：","content":"12个月"}]},
    //         {"type":"con1","isShowLine":true,"list":[{"label":"产品口感：","content":"清香型"},{"label":"适用人群：","content":"成人"}]},
    //         {"type":"con1","isShowLine":true,"list":[{"label":"出厂日期：","content":"2021.06.01"}]},
    //         {"type":"con1","isShowLine":false,"list":[{"label":"产品功效：","content":"含有丰富的Mg、Zn、Se等人体必需元素，还有多种对人体有益的氨基酸和丰富的维生素P。"}]},
    //         {"type":"mulImage","paddTop":0,"paddLeft":0,"align":"left","picList":[{"url":"/api/base/page/6d1acdfb5a1f2b57b3d407218c4c9f0c.png","width":"100.00%"}]},
    //         {"type":"tit1","marginTop":0,"marginLeft":10,"paddTop":9,"paddLeft":10,"content":"Shennong Jincha ","align":"center","fontSize":12,"fontWeight":"normal","textColor":"#1D211D","isShowLine":false,"lineColor":"#1D211D"},
    //         {"type":"tit1","marginTop":0,"marginLeft":10,"paddTop":7,"paddLeft":10,"content":"价值功效","align":"center","fontSize":18,"fontWeight":"bold","textColor":"#1D211D","isShowLine":true,"lineColor":"#1D211D"},
    //         {"type":"image","picList":[{"url":"/api/base/page/7b6e80c42678076bc50ccdd68a69d051.png","width":"100"}],"paddTop":10,"paddLeft":0},
    //         {"type":"image","picList":[{"url":"/api/base/page/415867ba2fc4ee7ed18c1f1d663852f2.png","width":"100"}],"paddTop":10,"paddLeft":0},
    //         {"type":"image","picList":[{"url":"/api/base/page/353e626ff66b76dda3299df9ea71480e.png","width":"100"}],"paddTop":10,"paddLeft":0},
    //         {"type":"image","picList":[{"url":"/api/base/page/3d48aabc16727d26f60a20e3a117464e.png","width":"100"}],"paddTop":10,"paddLeft":0},
    //         {"type":"image","picList":[{"url":"/api/base/page/7fbd9a6909d862f7ce2f92f240cb0e02.png","width":"100"}],"paddTop":10,"paddLeft":0},
    //         {"type":"detailBlock1","bgColor":"rgba(125, 176, 154, 1)","conBgColor":"#fff","paddLeft":10,"paddTop":10,"isShowLine":true,"lineType":1,"title":"关于神农晋茶","titleColor":"#000","titleSize":18,"enTitle":"About Shennong Jincha","enTitleColor":"#000","enTitleSize":12,"contents":[{"content":"         山西神农氏晋茶作为山西省首批授权使用“山西药茶”区域公用品牌的企业，以山西省丰富的野生连翘资源为基础，集成制药及食品研究关键技术，打造具有山西道地特色的山西药茶品牌，挖掘山西道地药材资源价值，助力我省山西药茶产业发展。研究分析表明，连翘叶中含有丰富的Mg、Zn、Se等人体所需元素以及多种对人体有益的氨基酸和丰富的维生素P；连翘叶采摘的最佳时期是4月中旬-6月中旬，嫩芽的品质最好。"},{"content":"连翘叶茶饮在山西历史悠久，民间用连翘嫩叶制成茶饮用的历史已有数百年，在乾隆年间，山西产的连翘茶曾被当做贡品。科学研究表明，连翘叶提取物可以保护人体细胞免受氧化损伤，治温热，降血脂，散诸经血结气聚，具有败火散结，保肝护肝、生津利咽、清凉提神等功效。因此，富含多种营养成分、无公害、纯绿色的野生连翘茶是人们健康生活应备的品质好茶。目前神农晋茶生产基地位于运城市绛县，采用了自主知识产权的山西药茶特制生产线，并由浙江知名茶叶生产线制造商进行制造。"},{"content":"神农晋茶目前集连翘叶、党参、蒲公英、黄精等食药同源材料的采摘、种植、生产、加工、安全检测、产品研发、全渠道销售、文化研究推广于一体，在山西省晋中市、运城市、长治市、临汾市等地规划建有全国领先且具有独立知识产权的现代化大中型生产线及原料基地，力争成为奉献健康、改变生活方式的行业领头羊。"}],"contentColor":"#000","contentSize":12}
    //         ]
    //     }

    //   }
    // ]

      
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.currentPage = num;
      this.selectOrdersInfoPcAsync();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.selectOrdersInfoPcAsync();
    }
  },
};
</script>

<style scoped lang='scss'>
.listContainer{
  background: #fff;
  // height: calc(100vh - 150px);
  display: border-box;
  padding-bottom: 30px;
  position: relative;
  padding-top: 20px;
}
.itemWrap{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  overflow-y: scroll;
  overflow-x: hidden;
}

.itemBlockWrap{
  width: 188px;
  height: 340px;
  margin: 20px;
}
.itemBlock{
  width: 100%;
  height: 300px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border: 1px solid #ccc;
  overflow: hidden;
  position: relative;
  background-color: #efefef;
}
.my_pagination{
  position: absolute;
  right: 0;
  bottom: 30px;
}
.itemBlock:hover .itemBlockMask{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
.itemBlockMask{
  display: none;
  position: absolute;
  z-index: 2;
  left:0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0,0,0,0.5);
}
.itemButton{
  width: 80px;
  height: 30px;
  margin: 10px 0;
}
.itemTitle{
  color: #333;
  line-height: 40px;
  text-align: center;
}
</style>
